import React, { forwardRef } from 'react'
import { Card, Row, Col, DropdownProps } from 'react-bootstrap'
import './index.css'

interface Props {
  children: any;
  className?: string;
}

interface MegaMenuChildProps {
  value: string;
  children: React.ReactNode;
}

const MegaMenu = forwardRef<HTMLDivElement, Props & DropdownProps>(
  ({ children, className = '' }, ref) => {
    const childArray = React.Children.toArray(children).filter(Boolean)

    const labelledby =
      childArray.length === 1
        ? 'dropdown-custom-components-account'
        : 'dropdown-custom-components'

    return (
      <div
        ref={ref}
        className={className}
        aria-labelledby={labelledby}
        role="menu"
      >
        <Row className="megamenuRow">
          {childArray.map((child, index) => {
            if (!React.isValidElement<MegaMenuChildProps>(child)) return null

            return (
              <Col key={index}>
                <Card className="megamenuCard">
                  <Card.Body className="megamenuCardBody">
                    <Card.Title className="megamenuCardTitle">
                      {child.props.value}
                    </Card.Title>
                    <hr />
                    {child.props.children}
                  </Card.Body>
                </Card>
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }
)

MegaMenu.displayName = 'MegaMenu';

export default MegaMenu